import { useEffect, useReducer, useState } from "react"

const largeScreenSize = 1280
const desktopScreenSize = 768

export enum Devices {
    Mobile,
    Desktop
}

export function device(): Devices {
    return isMobile() ? Devices.Mobile : Devices.Desktop
}

export function isMobile(): boolean {
    return (/Mobi|Android/i.test(navigator.userAgent))
}

export function deviceLangCode(): string {
    return navigator.language.split("-")[0] ?? 'pl'
}

export function isLargeScreen(): boolean {
    return window.innerWidth > largeScreenSize
}

export function isDesktopScreen(): boolean {
    return window.innerWidth > desktopScreenSize
}

export const useResize = () => {
    const [, forceUpdate] = useReducer(x => x + 1, 0)
    useEffect(() => {
        const handleResize = () => forceUpdate()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
}

export const useResponsiveChange = () => {
    const [screenState, setScreenState] = useState({
        isLarge: isLargeScreen(),
        isDesktop: isDesktopScreen(),
    })

    useEffect(() => {
        const handleResize = () => {
            const newIsLarge = isLargeScreen()
            const newIsDesktop = isDesktopScreen()

            // Update state only if values have changed
            setScreenState(prevState => {
                if (
                    prevState.isLarge !== newIsLarge ||
                    prevState.isDesktop !== newIsDesktop
                ) {
                    return { isLarge: newIsLarge, isDesktop: newIsDesktop }
                }
                return prevState
            })
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return screenState
}